const messages = {
    en: {
        commenttSuccess: "Comment has been added successfully",
        commenttError: "Error while adding comment",
        maximumNumberOfComments: "Maximum number of comments",
        perDay: " per day"
    },
    ru: {
        commenttSuccess: "Комментарий успешно добавлен",
        commenttError: "Ошибка при добавлении комментария",
        maximumNumberOfComments: "Максимальное количество комментариев",
        perDay: " в день"
    }
  };

  export default messages;